///<amd-module name="typeahead/core/message/SubmitClickedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class SubmitClickedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.submit_clicked";
    }

    constructor(private rfrrIdPrefix: string, private event?: JQueryEventObject) {}

    public getTopic(): string {
        return SubmitClickedMessage.getTopic();
    }

    public getRfrrIdPrefix(): string {
        return this.rfrrIdPrefix;
    }

    public getEvent(): JQueryEventObject {
        return this.event;
    }
}
